// Белый список навигации: Главная → Продукты → Разделяй упаковку (+ «Купить онлайн» отдельно в шаблоне).
// Пункты CMS вне списка (новинки, Pulpy-сериал и т.д.) не показываем.
export const NAV_ORDER = ['главная', 'продукты', 'разделяй упаковку'];

function normalizeTitle(title) {
  return String(title || '').trim().toLowerCase();
}

function navSortIndex(title) {
  const index = NAV_ORDER.indexOf(normalizeTitle(title));

  return index === -1 ? NAV_ORDER.length : index;
}

function isAllowedNavLink(item) {
  return NAV_ORDER.includes(normalizeTitle(item.attributes?.title));
}

export function sortNavMenuItems(list) {
  return [...(Array.isArray(list) ? list : [])]
    .filter(isAllowedNavLink)
    .sort(
      (a, b) =>
        navSortIndex(a.attributes?.title) - navSortIndex(b.attributes?.title),
    );
}
